var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgImage35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "MuiSvgIconroot-0-2-35 makeStylesstrokeIcon-0-2-33 MuiSvgIconfontSizeSmall-0-2-42",
    focusable: "false",
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "transparent",
    fillRule: "evenodd",
    d: "M6.5 0C2.9101 0 0 2.9101 0 6.5S2.9101 13 6.5 13c1.4341 0 2.7597-.4644 3.8347-1.2511l3.9582 3.9582c.3905.3905 1.0237.3905 1.4142 0 .3905-.3905.3905-1.0237 0-1.4142l-3.9582-3.9582C12.5356 9.2597 13 7.9341 13 6.5 13 2.9101 10.0899 0 6.5 0zM2 6.5C2 4.0147 4.0147 2 6.5 2S11 4.0147 11 6.5 8.9853 11 6.5 11 2 8.9853 2 6.5z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImage35);
export default __webpack_public_path__ + "static/media/svg-image-35.4171c3f2fcab5a11ac0e0b1feb4bf0ef.svg";
export { ForwardRef as ReactComponent };